import { render, staticRenderFns } from "./SortColumnIcon.vue?vue&type=template&id=038159d2&"
import script from "./SortColumnIcon.vue?vue&type=script&lang=ts&"
export * from "./SortColumnIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports